import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerLowSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998V3.911l-1.627 1.308-5.058 4.066H3.001v6.288h3.372l5.085 3.27 1.541.992V5.998Zm-5.706 5.067 3.705-2.98v8.085l-3.79-2.438-.248-.16h-1.96v-2.287H7.02l.274-.22Zm8.84-1.592-.815-.58-1.16 1.63.816.58c.088.063.166.138.229.22l.007.01c.378.483.29 1.187-.245 1.576l-.809.589 1.177 1.617.809-.589c1.419-1.033 1.74-3.018.647-4.42a3.071 3.071 0 0 0-.656-.633Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerLowSharpLine);
export default Memo;
